// Firebase configuration
// export const firebaseConfig = {
//   apiKey: "AIzaSyCyFtLJbzVgSrcrChao_YVAMxkKRAN2Pl8",
//   authDomain: "booz-288a4.firebaseapp.com",
//   projectId: "booz-288a4",
//   storageBucket: "booz-288a4.appspot.com",
//   messagingSenderId: "855942600427",
//   appId: "1:855942600427:web:164c0a578f34117cb790ae",
//   measurementId: "G-6BYBDN99P0",
// };

export const firebaseConfig = {
  apiKey: "AIzaSyB6J11kffipDhGqMwNpup8Os7r8oix3ick",
  authDomain: "booz-web.firebaseapp.com",
  projectId: "booz-web",
  // storageBucket: "booz-web.firebasestorage.app",
  storageBucket: "booz-web.appspot.com",
  messagingSenderId: "1015113767198",
  appId: "1:1015113767198:web:f6d490aa72fb93366ed10f"
};

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const navigate = useNavigate();

// // Function to store user details (you need to define this)
// const storeUserDetails = async (user) => {
// };

// // Google Login
// export const handleGoogleLogin = async (navigate) => {
//   const provider = new GoogleAuthProvider();
//   provider.setCustomParameters({ prompt: "select_account" });

//   try {
//     const result = await signInWithPopup(auth, provider);
//     await storeUserDetails(result.user);
//     navigate("/dashboard");
//   } catch (error) {
//     console.error("Google Login Error:", error.message);
//   }
// };

// // Facebook Login
// export const handleFacebookLogin = async (navigate) => {
//   const provider = new FacebookAuthProvider();

//   try {
//     const result = await signInWithPopup(auth, provider);
//     console.log("Facebook Login Success:", result);
//     await storeUserDetails(result.user);
//     navigate("/dashboard");
//   } catch (error) {
//     console.error("Facebook Login Error:", error.message);
//   }
// };
